/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const IncidentStatusCommand = zod.object({});

export type IncidentStatusCommand = zod.input<typeof IncidentStatusCommand>;
export type IncidentStatusCommandOutput = zod.output<typeof IncidentStatusCommand>;
